import { Api } from "../services"
export class Environment {
  api: Api
}
